import { Switch } from "@/components/ui/switch";
import { useUpdateInvoicePaymentStatusMutation } from "@/services/tax/tax-workflow";

export function PayedSwitchCell({ row }: { row: any }) {
  const [updatePayment, { isLoading }] = useUpdateInvoicePaymentStatusMutation();
  const isPayed = row.original?.is_payed;
  const id = row.original?.id;

  const handleChange = async (checked: boolean) => {
    try {
      await updatePayment({ id, is_payed: checked }).unwrap();
    } catch (e) {
      console.log(e)
    }
  };

  return (
    <div className="flex items-center justify-center">
      <Switch
        checked={isPayed}
        disabled={isLoading}
        onCheckedChange={handleChange}
        aria-label="Foi Pago?"
      />
    </div>
  );
}
